var map = {
	".": "e6c9",
	"./": "e6c9",
	"./array.prototype": "55c1",
	"./array.prototype.js": "55c1",
	"./index": "e6c9",
	"./index.js": "e6c9",
	"./number.prototype": "d4d6",
	"./number.prototype.js": "d4d6",
	"./string.prototype": "a66b",
	"./string.prototype.js": "a66b",
	"./vue.prototype": "4285",
	"./vue.prototype.js": "4285",
	"./window.prototype": "f9d4",
	"./window.prototype.js": "f9d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b3c9";